import type {
  ProductData,
  StoreFunnelSettingsFields,
  StoreFunnelStep,
} from '@innogy/feh/models';

import { mapStoreFunnelSettingsFields } from './map-store-funnel-settings';
import { initializeStoreFunnelStepAction } from '../store';

export function initializeStoreFunnelComponent(
  step: StoreFunnelStep,
  funnelSettings: StoreFunnelSettingsFields | null | undefined,
  productList?: ProductData[]
) {
  return initializeStoreFunnelStepAction({
    step,
    funnelSettings: mapStoreFunnelSettingsFields(funnelSettings, productList),
  });
}
